import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import axios from "axios";
import AppConfig from '../config/app-config'
export const checkLoginDetailsApi = async (userEmail, clientType = 2) => {
  const url = `${AppConfig.BASE_SERVER}/user?userEmail=${userEmail}&clientType=${clientType}`;
  let responseData = {
      status: false,
      data: null
  };
  await axios
    .get(url)
    .then((response) => {
        const { status, data = null } = response;
      responseData = {
          status: status === 200 ? true : false,
          data
      };
      console.log("response : ", responseData);
      // NotificationManager.success("User successfully logged in", "", 3000);
    })
    .catch((err) => {
      console.log("error : ", err);
      // NotificationManager.error("Invalid login details", "", 3000);
    });
  return responseData;
};

export const getPanelStreetLightInfo = async ({zoneId = 0, wardId = 0}) => {
  const url = `https://us-central1-ccms-dindigul-qe.cloudfunctions.net/device-summary?zoneId=${zoneId}&wardId=${wardId}`;
  let responseData = null;
  await axios
    .get(url)
    .then((response) => {
      responseData = response;
      console.log("response : ", responseData);
    })
    .catch((err) => {
      responseData = null;
      console.log("error : ", err);
    });
  return responseData;
};
